import { store } from '@src/state/store';
import { setPlayerMeta } from '@src/state/slices/slice_game';

export default () => (data: any) => {
  store.dispatch(setPlayerMeta({ playerId: data.playerId, name: data.name }));
};
